import React from "react";

import PropTypes from "prop-types";

import { Typography } from "antd";
const { Title, Text } = Typography;

export const InformationComponent = ({title, attribute}) => {
	return (
		<div>			
			<Title level={4}>{title}</Title>
			<Text>{attribute}</Text>
		</div>
	);
};

InformationComponent.propTypes = {
	title: PropTypes.string,
	attribute: PropTypes.string,
};